module.exports = __webpack_public_path__ + "img/logo-white.d4dfe10e.svg";